import React, { useEffect, useState } from "react";
import Card from "components/card";
import { MdDelete as DeleteIcon, MdVisibility as VisibilityIcon } from "react-icons/md";
import DataTable from "components/Datatable/Datatable";
import { GridColDef } from "@mui/x-data-grid";
import { deleteDataById, fetchData } from "api";
import { users } from "api/collection_names";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { SnackbarState } from "models/user-models";
import AppSnackbar from "components/snakbar";
import UserDataModal from "usefulComponents/Modal/UserDataModal";


export interface SystemsType {
    description: string
    priority: number
    _id?: string
}

export interface UpdateSystemsType {
    description: string
    _id?: string
}

const CRMDashboard = () => {
    const [rows, setRows] = useState<[]>([])
    const [selectedUser, setSelectedUser] = useState<any>({})

    const [loading, setLoading] = useState<boolean>(false)
    const [snackbar, setSnackbar] = useState<SnackbarState>({
        open: false,
        message: '',
        severity: 'info',
    });

    const navigate = useNavigate()
    useEffect(() => {
        getUsers()
    }, [])


    const getUsers = async () => {
        try {
            setLoading(true)
            const res = await fetchData(users)
            if (res.success) {
                const updatedData = res.data.map((item: any) => {
                    return {
                        ...item,
                        fullname: item.fname + " " + item.lname
                    }
                })

                const filteredArray = updatedData.filter((item: any) => item.type !== "1");

                console.log("CRM Users: ", res.data)
                setRows(filteredArray)
            }
            else {
                setRows([])

                // const isTokenExpired = () => {
                //     const expirationTime = localStorage.getItem('expirationTime');
                //     if (!expirationTime) return true;
                //     return new Date().getTime() > Number(expirationTime);
                //   };
                //   console.log("isTokenExpired++++++",isTokenExpired())

                //   if (isTokenExpired()) {
                //     localStorage.removeItem('expirationTime');
                //     navigate('/auth/sign-in'); 
                //   } 
                //   navigate('/auth/sign-in'); 
                alert("No System found...!")
                navigate('/auth/sign-in');
            }
            setLoading(false)
        } catch (error: any) {
            const alreadyLoggedIn = error.message.endsWith("401")
            if (alreadyLoggedIn) {
                setSnackbar({ open: true, message: "logged in from some other device", severity: 'error' });
                setTimeout(() => {
                    navigate('/auth/sign-in');
                }, 3000)
            }
        }
    }


    const [userDataModel, setUserDataModel] = useState(false)
    const handleOpen = (data: any) => {
        setSelectedUser(data)
        setUserDataModel(true)
    };

    const handleClose = () => setUserDataModel(false);

    const columns: GridColDef[] = [
        { field: "fullname", headerName: "Name", flex: 9 },
        {
            field: "status",
            headerName: "Status",
            flex: 2,
            sortable: false,
            renderCell: (params: any) => (
                <>
                    {params.row.subscription === "active" ? <span className="flex justify-center items-center relative px-2.5 py-1.5 w-24 bg-[#4318FF] rounded-2xl text-white text-[12px]">Subscribed</span> : <span className="flex justify-center items-center relative px-2.5 py-1.5 w-24 bg-[#20c0ff] rounded-2xl text-white text-[12px]">Trial</span>}
                </>
            ),
        },
        {
            field: "actions",
            headerName: "Actions",
            flex: 2,
            sortable: false,
            renderCell: (params: any) => (
                <>
                    <Button
                        title="View Details"
                        variant="contained"
                        sx={{
                            width: '30px',
                            height: '30px',
                            minWidth: '30px',
                            mr: '5px',
                            padding: 0,
                            background: "var(--color-download-btn-surface, #3B82F6)",
                            color: "var(--color-download-btn-icon, white)",
                            "&:hover": { background: "var(--color-download-btn-surface, #3B82F6)", opacity: 0.8 },
                            "&:active": { background: "var(--color-download-btn-surface, #3B82F6)", opacity: 0.7 },
                        }}
                        onClick={() => handleOpen(params.row)}>
                        <VisibilityIcon fontSize="small" />
                    </Button>

                    <Button
                        title="Delete"
                        sx={{
                            width: '30px',
                            height: '30px',
                            minWidth: '30px',
                            mr: '5px',
                            padding: 0,
                            background: "#ff0000",
                            color: "white",
                            "&:hover": { background: "#ff0000", opacity: 0.8 },
                            "&:active": { background: "#ff0000", opacity: 0.7 },
                        }}
                        variant="contained"
                        onClick={async () => {
                            /* eslint-disable no-restricted-globals */
                            if (confirm(`Are you sure to delete ${params.row.fullname} have an id (${params.row._id}) ?`)) {
                                const res = await deleteDataById(users, params.row._id)
                                if (res.success) {
                                    getUsers()
                                }
                                else {
                                    alert(res.message)
                                }
                            }
                        }}>
                        <DeleteIcon fontSize="small" />
                    </Button>
                </>
            ),
        }
    ];

    return (
        <div>
            <div className="mt-5">
                <Card extra={"w-full h-full sm:overflow-auto px-8"}>
                    <header className="relative flex items-center justify-between py-5">
                        <h1 className="text-[26px] text-black font-semibold w-[100%] sm:w-[70%]">Customer Relationship Management</h1>
                    </header>

                    <UserDataModal openModal={userDataModel} title="Profile Details" cancelButtonText="Close" onClose={handleClose} >
                        <div className="mt-10 flex justify-between items-center w-[100%]">
                            <div className="w-[450px] mr-5">

                                <p className="block relative text-[12px] font-medium text-[#0000009f] leading-none">Full name:</p>
                                <h1 className="block text-md text-black">{selectedUser?.fullname ? selectedUser.fullname : "N/A"}</h1>

                                <p className="block relative text-[12px] font-medium text-[#0000009f] mt-4 leading-none">Email:</p>
                                <h1 className="block text-md text-black">{selectedUser?.email ? selectedUser.email : "N/A"}</h1>

                                <p className="block relative text-[12px] font-medium text-[#0000009f] mt-4 leading-none">Contact:</p>
                                <h1 className="block text-md text-black">{selectedUser?.contact ? selectedUser.contact : "N/A"}</h1>

                                <p className="block relative text-[12px] font-medium text-[#0000009f] mt-4 leading-none">Status:</p>
                                <h1 className="block text-md text-black">{selectedUser.subscription === "active" ? 'Subscribed' : 'Trial'}</h1>

                                {selectedUser.subscription === "active" && <>
                                    <p className="block relative text-[12px] font-medium text-[#0000009f] mt-4 leading-none">Subscribtion Type:</p>
                                    <h1 className="block text-md text-black">{selectedUser.subscription === "active" ? selectedUser.package_name : 'N/A'}</h1>
                                </>
                                }

                                <p className="block relative text-[12px] font-medium text-[#0000009f] mt-4 leading-none">{
                                    selectedUser.subscription === "active" ? 'Subscription valid till:' : 'Trial valid till:'
                                }</p>
                                <h1 className="block text-md text-black">{
                                    selectedUser.subscription === "active" ? selectedUser?.expiryTime?.slice(0, 10) || "N/A" : selectedUser?.trial_expiry?.slice(0, 10) || "N/A"
                                }</h1>

                                <p className="block relative text-[12px] font-medium text-[#0000009f] mt-4 leading-none">Date of birth:</p>
                                <h1 className="block text-md text-black">{selectedUser?.dob?.slice(0, 10) || "-"}</h1>

                                <p className="block relative text-[12px] font-medium text-[#0000009f] mt-4 leading-none">Joined on:</p>
                                <h1 className="block text-md text-black">{selectedUser?.created_at?.slice(0, 10) || "-"}</h1>
                            </div>
                        </div>
                    </UserDataModal>

                    <div>
                        <DataTable columns={columns} rows={rows} loading={loading} />
                    </div>
                </Card>
            </div>
            <AppSnackbar
                isOpen={snackbar.open}
                title={snackbar.message}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                severity={snackbar.severity}
            />
        </div>
    );
};

export default CRMDashboard;